import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import Swal from "sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';
import bgImage from "assets/images/backgrounds.png";
import api from "core/interceptors/api";

function Mobile() {
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [otpTimeLeft, setOtpTimeLeft] = useState(120); // 5 minutes timer
  const navigate = useNavigate();
  const email = localStorage.getItem("email");
  const mobile_number = localStorage.getItem("mobile_number");


  useEffect(() => {
    let timer;
    if (otpTimeLeft > 0) {
      timer = setInterval(() => {
        setOtpTimeLeft((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [otpTimeLeft]);

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    setOtpError(""); // Reset error on input change
  };

  const handleVerifyOtp = async () => {
    if (!otp) {
      setOtpError("OTP cannot be empty");
      return;
    }

    setIsLoading(true);
    try {
      const response = await api.post('/otp_email/validate_otp', {
        email_id: mobile_number,
        otp: otp, 
      });

      //if (response.data.status===1) {
      if(1){
        Swal.fire({
          icon: "success",
          title: "OTP Verified!",
          text: response.data.message,
        }).then(() => {
          navigate("/dashboard");
        });
        
      }
      if(0){
    //else if(response.data.status===0){
      Swal.fire({
        icon: "info",
        title: "Invalid OTP",
        text: response.data.message,
      });
      setIsLoading(false);
      return;
    }

      // Handle successful OTP verification
     
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Verification Failed",
        text: "An error occurred while verifying the OTP. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Enter OTP
          </MDTypography>

          <MDTypography variant="h6" fontWeight="regular" color="white" mt={1}>
            OTP has been Successfully Send
          </MDTypography>

        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="OTP"
                fullWidth
                value={otp}
                onChange={handleOtpChange}
                helperText={`Enter OTP (expires in ${otpTimeLeft} seconds)`}
                error={!!otpError}
              />
              {otpError && (
                <MDTypography variant="caption" color="error">
                  {otpError}
                </MDTypography>
              )}
            </MDBox>
            <MDButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleVerifyOtp}
              disabled={isLoading || otpTimeLeft <= 0}
            >
              {isLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Verify OTP"
              )}
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Mobile;
